import { CSSProperties } from "react";
import { DCUIContentFooter, DCUIThemeFooter } from "@iddataweb/idw-common-ui/types";
import styles from "./dcui-theming-footer-container.less";

type DCUIThemingFooterContainerProps = {
    footerContent: DCUIContentFooter;
    footerTheme: DCUIThemeFooter;
};

export const DCUIThemingFooterContainer = (props: DCUIThemingFooterContainerProps) => {
    const { footerContent, footerTheme } = props;

    const footerStyles: CSSProperties = {
        color: footerTheme.textColor,
        backgroundColor: footerTheme.backgroundColor
    };

    return (
        <div id="footer-container" className={styles.dcuiThemingFooterContainer} style={footerStyles}>
            <footer id="footer-content" className={styles.footerContent}>
                {(footerContent.text && footerContent.text !== ".")
                    ? <h3>{footerContent.text}</h3>
                    : null
                }
            </footer>
        </div>
    );
};
